import {Avatar, Box} from "@mui/material";
import React from "react";
import {User} from "../../models/User";

interface SidebarProfileProps {
    user: User,
}

export function SidebarProfile({user}: SidebarProfileProps) {
    return <>
        <Box height={"50px"}/>
        <Avatar sx={{width: 84, height: 84}} src={user.profileImage}/>
        <Box height={"12px"}/>
        <span className={"secondary-title-text"}>{user.name}</span>
    </>;
}